import React from 'react';
import './RealEstatePage.css';

function RealEstatePage() {
  return (
    <div className="page realestate-page">
      <section className="realestate-hero">
        <div className="realestate-hero-content">
          <h1>Inmobiliaria</h1>
        </div>
      </section>

      <section className="realestate-content">
        <div className="content-container">
          <div className="intro-text">
            <h2 className="intro-title">Especialistas en Intermediación e Inversión Inmobiliaria</h2>
            <p>
              TABIA Inmobiliaria es la compañía del Grupo TABIA especializada en la búsqueda, análisis e 
              intermediación de productos inmobiliarios, tanto en operaciones de compra y venta como de 
              arrendamiento, con un foco principal en España y una presencia creciente en otros mercados europeos.
            </p>
            <p>
              Prestamos servicio a compradores y vendedores, así como a arrendadores y arrendatarios, 
              acompañándolos en la identificación de la oportunidad más adecuada en cada momento, siempre en 
              función de sus objetivos y de las condiciones del mercado en términos de ubicación, tipología de 
              activo, precio, rentabilidad y perfil de riesgo.
            </p>
            <p>
              Nuestro enfoque se basa en un profundo conocimiento del mercado inmobiliario, combinado con una 
              metodología rigurosa de análisis y una visión estratégica que nos permite anticipar oportunidades 
              y estructurar operaciones de forma eficiente y segura.
            </p>
          </div>

          <div className="section-block">
            <h2>Eficiencia operativa y enfoque a resultados</h2>
            <p>
              La actividad de TABIA Inmobiliaria está orientada a la optimización de tiempos y recursos, 
              garantizando procesos ágiles y una toma de decisiones informada. Nuestra estructura nos permite 
              reducir fricciones en la intermediación, filtrar oportunidades de manera precisa y concentrar los 
              esfuerzos exclusivamente en aquellas operaciones que aportan valor real a nuestros clientes.
            </p>
            <p>
              Este enfoque eficiente es especialmente relevante para las familias y clientes en gestión 
              patrimonial, ya que permite integrar de forma natural la intermediación inmobiliaria dentro de una 
              estrategia global de gestión y rotación de activos, alineada con los objetivos patrimoniales definidos.
            </p>
          </div>

          <div className="section-block">
            <h2>Red de contactos estratégica</h2>
            <p>
              TABIA Inmobiliaria se apoya en una extensa y consolidada red de contactos, desarrollada de forma 
              orgánica a lo largo de los años, que incluye propietarios, inversores, family offices, promotores, 
              operadores, fondos de inversión, entidades financieras y otros profesionales del sector.
            </p>
            <p>
              Esta red no solo nos permite acceder a oportunidades fuera de mercado (off-market), sino que 
              constituye un elemento clave para complementar y reforzar el servicio de gestión patrimonial 
              inmobiliaria que TABIA presta a las familias y clientes bajo gestión. Gracias a ello, podemos 
              ofrecer soluciones integrales que abarcan desde la identificación de oportunidades hasta su 
              incorporación, rotación o desinversión dentro de carteras previamente estructuradas.
            </p>
          </div>

          <div className="section-block highlight">
            <h2>Un servicio integrado dentro del Grupo TABIA</h2>
            <p>
              TABIA Inmobiliaria actúa de forma coordinada con TABIA Gestión, lo que nos permite ofrecer un 
              servicio inmobiliario alineado con la estrategia patrimonial global de cada cliente. Esta integración 
              facilita una visión transversal de los activos y del mercado, aportando mayor coherencia, control y 
              generación de valor a largo plazo.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RealEstatePage;
